import { useEffect, useState } from "react";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";

type TItem = {
  key: string | number;
  value: string;
};

const SelectList = ({
  defaultSelectedItem,
  data,
  onSelect,
}: {
  defaultSelectedItem: TItem;
  data: Array<TItem>;
  onSelect: Function;
}) => {
  const [showOptionList, setShowOptionList] = useState(false);
  const [selectedItem, setSelectedItem] = useState(defaultSelectedItem);

  const handleListDisplay = () =>
    setShowOptionList((showOptionList) => !showOptionList);

  const handleOnSelect = (item: TItem) => {
    setShowOptionList(false);
    setSelectedItem(item);
    onSelect(item);
  };

  return (
    <div className="w-60">
      <div
        className={`flex flex-row bg-neutral-600 w-full pl-6 pr-4 py-4 ${
          showOptionList ? "rounded-t-lg" : "rounded-lg"
        } items-center`}
        onClick={handleListDisplay}
      >
        <span className="flex flex-1 text-gray-300">
          {selectedItem?.value ?? "Select Item"}
        </span>
        {showOptionList ? (
          <AiFillCaretUp fill="#d4d4d8" size={18} />
        ) : (
          <AiFillCaretDown fill="#d4d4d8" size={18} />
        )}
      </div>
      {showOptionList && (
        <ul className="absolute w-60 bg-neutral-600 divide-y rounded-b-lg border-t">
          {data.map((item) => {
            return (
              <li
                className={`${
                  selectedItem?.key === item.key
                    ? "text-gray-300"
                    : "text-gray-300 font-medium"
                } pl-6 p-4`}
                data-name={item.value}
                key={item.key}
                onClick={() => handleOnSelect(item)}
              >
                {item.value}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default SelectList;
